// Mock data for momentIA - AI event photography platform

export const brandLogos = [
  { name: 'Netflix', text: 'NETFLIX' },
  { name: 'BMW', text: 'BMW' },
  { name: 'Louis Vuitton', text: 'LOUIS VUITTON' },
  { name: 'Rolex', text: 'ROLEX' },
  { name: 'Juventus', text: 'JUVENTUS' },
  { name: 'Campari', text: 'CAMPARI' },
  { name: 'Hublot', text: 'HUBLOT' },
  { name: 'EY', text: 'EY' },
  { name: 'Inter', text: 'INTER' },
  { name: 'YSL', text: 'YSL' },
  { name: 'Chase', text: 'CHASE' },
  { name: 'Xterra', text: 'XTERRA' },
];

export const heroImages = {
  main: 'https://images.unsplash.com/photo-1501281668745-f7f57925c3b4?crop=entropy&cs=srgb&fm=jpg&q=85',
  crowd: 'https://images.pexels.com/photos/34675440/pexels-photo-34675440.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  selfie: 'https://images.unsplash.com/photo-1713812956759-371b4e8fc468?crop=entropy&cs=srgb&fm=jpg&q=85',
};

// Mosaic photos scattered around hero — individual people visible
export const heroMosaic = {
  left: [
    { src: 'https://customer-assets-cm19k8pv.emergentagent.net/job_vende-fotos-pro/artifacts/i3ul0nt8_happy-family-amazed-with-seashell.webp', alt: 'familia en la playa', size: 'sm', rotate: -6 },
    { src: 'https://customer-assets-cm19k8pv.emergentagent.net/job_vende-fotos-pro/artifacts/obw5sys7_group-friends-eating-restaurant.webp', alt: 'amigos brindando en restaurante', size: 'md', rotate: 4 },
    { src: 'https://customer-assets-cm19k8pv.emergentagent.net/job_vende-fotos-pro/artifacts/mtxdx8fo_sugar-golf-mqQ0BuJ5dsA-unsplash.webp', alt: 'golfistas brindando', size: 'lg', rotate: -3 },
    { src: 'https://customer-assets-cm19k8pv.emergentagent.net/job_vende-fotos-pro/artifacts/vjzq73nf_v2_951633a9-7ca3-402e-8362-1edc9a2ee9b3%20%281%29.jpg.webp', alt: 'hinchas de fútbol', size: 'sm', rotate: 8 },
  ],
  right: [
    { src: 'https://customer-assets-cm19k8pv.emergentagent.net/job_vende-fotos-pro/artifacts/uif0bxbo__DSC6558.webp', alt: 'hincha argentino en el estadio', size: 'md', rotate: 5 },
    { src: 'https://images.unsplash.com/photo-1501386761578-eac5c94b800a?crop=entropy&cs=srgb&fm=jpg&q=85&w=500', alt: 'hincha en el estadio', size: 'sm', rotate: -7 },
    { src: 'https://images.unsplash.com/photo-1622314873267-d44e38cdd652?crop=entropy&cs=srgb&fm=jpg&q=85&w=500', alt: 'ciclista', size: 'lg', rotate: 4 },
    { src: 'https://images.unsplash.com/photo-1700558154233-233332b5fe41?crop=entropy&cs=srgb&fm=jpg&q=85&w=500', alt: 'persona en evento', size: 'sm', rotate: -5 },
  ],
};

export const phoneMockups = {
  // Same woman shown across all 3 phone mockups (bar/event)
  personA: 'https://images.unsplash.com/photo-1671116810140-c237d1c66dc1?crop=entropy&cs=srgb&fm=jpg&q=85&w=600',
  personB: 'https://images.unsplash.com/photo-1671116810073-fd0d8e7dc4b4?crop=entropy&cs=srgb&fm=jpg&q=85&w=600',
  personC: 'https://images.unsplash.com/photo-1671116810083-8d34144ffc0f?crop=entropy&cs=srgb&fm=jpg&q=85&w=600',  // Album grid: variety of poses of the SAME woman at the event
  album1: 'https://images.unsplash.com/photo-1671116810140-c237d1c66dc1?crop=entropy&cs=srgb&fm=jpg&q=85&w=300',
  album2: 'https://images.unsplash.com/photo-1671116810073-fd0d8e7dc4b4?crop=entropy&cs=srgb&fm=jpg&q=85&w=300',
  album3: 'https://images.unsplash.com/photo-1671116810083-8d34144ffc0f?crop=entropy&cs=srgb&fm=jpg&q=85&w=300',
  album4: 'https://images.unsplash.com/photo-1644446640321-bf75393f1385?crop=entropy&cs=srgb&fm=jpg&q=85&w=300',
  album5: 'https://images.unsplash.com/photo-1600366060302-9fb7682b062b?crop=entropy&cs=srgb&fm=jpg&q=85&w=300',
  album6: 'https://images.unsplash.com/photo-1692735224370-91344ac4b68b?crop=entropy&cs=srgb&fm=jpg&q=85&w=300',
};

// Sports fans / athletes for the Fan Experience page — REAL fan photos supplied by user
export const fanImages = {
  // The 3 hero fan photos — Argentine rugby fans (Los Pumas vs Scotland vibe)
  heroFan: 'https://customer-assets.emergentagent.com/job_vende-fotos-pro/artifacts/idk554pk_Captura%20de%20pantalla%202026-07-08%20232111.png', // older man in blue/white hat
  visaFan: 'https://customer-assets.emergentagent.com/job_vende-fotos-pro/artifacts/vmz808se_Captura%20de%20pantalla%202026-07-08%20232122.png', // young man with beer helmet + Visa jersey
  paintedFan: 'https://customer-assets.emergentagent.com/job_vende-fotos-pro/artifacts/lo9v3vw9_Captura%20de%20pantalla%202026-07-08%20232144.png', // painted face + lion head + Imperial bg
  // Aliases so existing references keep working — mapped to real fan photos
  stadiumFans: 'https://customer-assets.emergentagent.com/job_vende-fotos-pro/artifacts/idk554pk_Captura%20de%20pantalla%202026-07-08%20232111.png',
  teamColors: 'https://customer-assets.emergentagent.com/job_vende-fotos-pro/artifacts/lo9v3vw9_Captura%20de%20pantalla%202026-07-08%20232144.png',
  athlete: 'https://customer-assets.emergentagent.com/job_vende-fotos-pro/artifacts/vmz808se_Captura%20de%20pantalla%202026-07-08%20232122.png',
  runner: 'https://customer-assets.emergentagent.com/job_vende-fotos-pro/artifacts/vmz808se_Captura%20de%20pantalla%202026-07-08%20232122.png',
  track: 'https://customer-assets.emergentagent.com/job_vende-fotos-pro/artifacts/lo9v3vw9_Captura%20de%20pantalla%202026-07-08%20232144.png',
  cyclist: 'https://customer-assets.emergentagent.com/job_vende-fotos-pro/artifacts/idk554pk_Captura%20de%20pantalla%202026-07-08%20232111.png',
  finisher: 'https://customer-assets.emergentagent.com/job_vende-fotos-pro/artifacts/vmz808se_Captura%20de%20pantalla%202026-07-08%20232122.png',
};

// Hospitality / hotel / resort / cruise photography
export const hospitalityImages = {
  // Family on the beach — hero
  familyBeach: 'https://images.pexels.com/photos/1231365/pexels-photo-1231365.jpeg?auto=compress&cs=tinysrgb&w=1200',
  familyBeachSunset: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  familyVilla: 'https://images.unsplash.com/photo-1602002418082-a4443e081dd1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  couplePool: 'https://images.unsplash.com/photo-1519046904884-53103b34b206?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  poolResort: 'https://images.unsplash.com/photo-1571003123894-1f0594d2b5d9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  kidsPool: 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  hotelLobby: 'https://images.unsplash.com/photo-1445019980597-93fa8acb246c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  spaWellness: 'https://images.unsplash.com/photo-1540555700478-4be289fbecef?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  restaurantDinner: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  excursion: 'https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  cruiseShip: 'https://images.unsplash.com/photo-1548574505-5e239809ee19?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  beachBar: 'https://images.unsplash.com/photo-1582719508461-905c673771fd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  breakfast: 'https://images.unsplash.com/photo-1533777324565-a040eb52facd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  yoga: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  kayak: 'https://images.unsplash.com/photo-1526947425960-945c6e72858f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  sunsetDeck: 'https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
};

// Endurance sports action photos
export const sportsImages = {
  marathon: 'https://images.unsplash.com/photo-1727094141271-9bea5bc8c757?crop=entropy&cs=srgb&fm=jpg&q=85&w=900',
  triathlon: 'https://images.unsplash.com/photo-1438029071396-1e831a7fa6d8?crop=entropy&cs=srgb&fm=jpg&q=85&w=900',
  mtb: 'https://images.unsplash.com/photo-1506316940527-4d1c138978a0?crop=entropy&cs=srgb&fm=jpg&q=85&w=900',
  mtbSplash: 'https://images.unsplash.com/photo-1606087492572-424ebe0f2f61?crop=entropy&cs=srgb&fm=jpg&q=85&w=900',
  trail: 'https://images.unsplash.com/photo-1718248028293-934f04a578db?crop=entropy&cs=srgb&fm=jpg&q=85&w=900',
  trailMountain: 'https://images.unsplash.com/photo-1530143311094-34d807799e8f?crop=entropy&cs=srgb&fm=jpg&q=85&w=900',
  ski: 'https://images.unsplash.com/photo-1616364513156-800d61231754?crop=entropy&cs=srgb&fm=jpg&q=85&w=900',
  cycling: 'https://images.unsplash.com/photo-1528629297340-d1d466945dc5?crop=entropy&cs=srgb&fm=jpg&q=85&w=900',
  obstacle: 'https://images.unsplash.com/photo-1522866348293-55be2c6caa1f?crop=entropy&cs=srgb&fm=jpg&q=85&w=900',
  finish: 'https://images.unsplash.com/photo-1766970096331-78c8af007a3b?crop=entropy&cs=srgb&fm=jpg&q=85&w=900',
  celebrate: 'https://images.unsplash.com/photo-1632766814518-09285fcc69c2?crop=entropy&cs=srgb&fm=jpg&q=85&w=900',
};

export const stats = [
  { value: '50.000+', label: 'Usuarios en el mundo' },
  { value: '10+', label: 'Clientes B2B' },
  { value: '25.000+', label: 'Fotos entregadas' },
  { value: '4', label: 'Países' },
  { value: '100%', label: 'Cumplimiento privacidad' },
];

export const howItWorks = [
  {
    step: '01',
    title: 'Se toma una selfie',
    description: 'El participante saca una selfie para acceder a su álbum privado en segundos.',
  },
  {
    step: '02',
    title: 'Ve sus fotos personales',
    description: 'Accede a sus fotos personales y al contenido promocional del evento, todo con tu marca.',
  },
  {
    step: '03',
    title: 'Descarga y comparte',
    description: 'Descarga y comparte sus fotos en redes sociales, multiplicando el alcance de tu marca.',
  },
];

export const forPhotographers = [
  {
    slug: 'vende-tus-fotos',
    title: 'Optimizá tus ventas',
    subtitle: 'Reducí tiempos de venta, cobra al instante y vendé tus fotos a cualquier persona del mundo. Cero comisión mensual — solo 30% cuando cobrás.',
    image: 'https://images.unsplash.com/photo-1452626038306-9aae5e071dd3?crop=entropy&cs=srgb&fm=jpg&q=85',
    to: '/vende-tus-fotos',
    external: false,
    highlights: ['Fotos y álbumes ilimitados', 'Pasarela de pagos integrada', 'Vendé al mundo entero, sin fronteras', 'Sin cargo mensual · solo 30% al cobrar'],
    cta: 'Empezar gratis',
  },
];

export const forEnterprise = [
  {
    slug: 'marcas',
    title: 'Marcas',
    subtitle: 'Activaciones y campañas que llegan al smartphone de tu audiencia',
    image: 'https://images.unsplash.com/photo-1519671482749-fd09be7ccebf?crop=entropy&cs=srgb&fm=jpg&q=85',
  },
  {
    slug: 'eventos',
    title: 'Corporativo y MICE',
    subtitle: 'Revolucioná la experiencia de tus invitados y potenciá tu ROI',
    image: 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?crop=entropy&cs=srgb&fm=jpg&q=85',
  },
  {
    slug: 'fan-experience',
    title: 'Experiencia del fan',
    subtitle: 'Convertí cada partido en un recuerdo inolvidable',
    image: 'https://images.unsplash.com/photo-1665035212282-3e117d618b36?crop=entropy&cs=srgb&fm=jpg&q=85',
  },
  {
    slug: 'deportes',
    title: 'Deportes y competencias',
    subtitle: 'Maratones, torneos, triatlones, MTB, trail y ligas: fotos en tiempo real que multiplican ventas',
    image: 'https://images.unsplash.com/photo-1452626038306-9aae5e071dd3?crop=entropy&cs=srgb&fm=jpg&q=85',
  },
  {
    slug: 'hospitality',
    title: 'Hospitality',
    subtitle: 'Cruceros, resorts y hoteles: nuevo revenue ancillary y guest satisfaction',
    image: 'https://images.pexels.com/photos/1231365/pexels-photo-1231365.jpeg?auto=compress&cs=tinysrgb&w=1200',
  },
  {
    slug: 'fotografos-on-demand',
    title: 'Fotógrafos on demand',
    subtitle: 'Red momentIA en toda LATAM. Nosotros seleccionamos, negociamos y coordinamos.',
    image: 'https://images.unsplash.com/photo-1554080353-a576cf803bda?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  },
  {
    slug: 'productoras',
    title: 'Productoras & Estudios',
    subtitle: 'Whitelabel para agencias, wedding studios y productoras. Cero comisión, eventos ilimitados.',
    image: 'https://images.unsplash.com/photo-1519741497674-611481863552?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  },
];

export const galleryImages = [
  { alt: 'Padre e hija en 21k La Plata', src: 'https://customer-assets-cm19k8pv.emergentagent.net/job_vende-fotos-pro/artifacts/9ydreebc_DSCF7470.jpg' },
  { alt: 'Chica con Modelo en fiesta', src: 'https://customer-assets-cm19k8pv.emergentagent.net/job_vende-fotos-pro/artifacts/9qecthlj_Gemini_Generated_Image_h8b13rh8b13rh8b1.webp' },
  { alt: 'Netflix event', src: 'https://images.unsplash.com/photo-1501281668745-f7f57925c3b4?crop=entropy&cs=srgb&fm=jpg&q=85' },
  { alt: 'XTERRA sports', src: 'https://images.unsplash.com/photo-1452626038306-9aae5e071dd3?crop=entropy&cs=srgb&fm=jpg&q=85' },
  { alt: 'Racing cars', src: 'https://images.unsplash.com/photo-1613936360976-8f35cf0e5461?crop=entropy&cs=srgb&fm=jpg&q=85' },
  { alt: 'Luxury event', src: 'https://images.unsplash.com/photo-1543728069-a3f97c5a2f32?crop=entropy&cs=srgb&fm=jpg&q=85' },
  { alt: 'Concert', src: 'https://images.pexels.com/photos/3122799/pexels-photo-3122799.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940' },
  { alt: 'Corporate gala', src: 'https://images.unsplash.com/photo-1531058020387-3be344556be6?crop=entropy&cs=srgb&fm=jpg&q=85' },
];

export const testimonials = [
  {
    name: 'Lorenzo Boglione',
    role: 'Senior Vice Chairman, Basic Net SPA · K-Way, Sebago, Kappa',
    quote: 'Hasta ahora estábamos prácticamente a ciegas sobre el engagement de nuestros invitados durante eventos en vivo. Con momentIA desbloqueamos un conjunto de insights totalmente nuevo que usamos para evaluar la participación y obtener un mejor retorno de inversión.',
    avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop',
  },
  {
    name: 'Francesco Calvo',
    role: 'Chief Football Officer, Juventus Football Club',
    quote: 'De lejos la forma más efectiva y atractiva de involucrar a nuestros fans y enriquecer nuestro CRM. Con momentIA encontramos la manera de entregar recuerdos reales directamente al smartphone de nuestros hinchas: recuerdos que muchos pegarán en la pared toda su vida.',
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=200&h=200&fit=crop',
  },
  {
    name: 'Massimo Angelini',
    role: 'Director de Comunicación, LUISS',
    quote: 'Cristalizar los momentos mágicos en la vida de nuestros estudiantes no tiene precio. Antes lo hacíamos, pero era muy engorroso distribuir las fotos. Ahora todo ese trabajo manual desapareció y los estudiantes reciben sus recuerdos en el teléfono, con nuestra marca.',
    avatar: 'https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=200&h=200&fit=crop',
  },
];

export const pricingPlans = [
  {
    name: 'Starter',
    price: '0',
    period: 'gratis',
    description: 'Para fotógrafos independientes que recién arrancan.',
    features: [
      'Hasta 1.000 fotos por mes',
      'Reconocimiento facial con IA',
      'Álbumes privados por rostro',
      'Pagos integrados (MP, Stripe)',
      'Comisión 15% por venta',
    ],
    cta: 'Empezar gratis',
    highlighted: false,
  },
  {
    name: 'Pro',
    price: '49',
    period: 'por mes',
    description: 'Para fotógrafos profesionales y estudios.',
    features: [
      'Fotos ilimitadas',
      'Reconocimiento facial con IA',
      'Marca personalizada en el álbum',
      'Analytics avanzados',
      'Comisión 10% por venta',
      'Soporte prioritario',
    ],
    cta: 'Empezar prueba',
    highlighted: true,
  },
  {
    name: 'Enterprise',
    price: 'Custom',
    period: 'a medida',
    description: 'Para eventos masivos, marcas y organizaciones.',
    features: [
      'Volumen ilimitado',
      'API y white-label',
      'Integraciones a medida',
      'CRM y captación de leads',
      'Comisiones negociables',
      'Customer Success dedicado',
    ],
    cta: 'Contactar ventas',
    highlighted: false,
  },
];

export const faqs = [
  {
    q: '¿Cómo funciona el reconocimiento facial?',
    a: 'El participante sube una selfie desde su celular. Nuestra IA la compara con las fotos del evento y le devuelve un álbum privado con todas las imágenes en las que aparece. No almacenamos datos biométricos después del match.',
  },
  {
    q: '¿Es privado y seguro?',
    a: 'Sí. No existen galerías públicas: cada persona ve únicamente sus propias fotos. Cumplimos con GDPR y las normativas locales de protección de datos.',
  },
  {
    q: '¿Cuánto tarda en procesar las fotos?',
    a: 'Nuestra IA procesa las fotos en tiempo real. Los asistentes pueden ver sus imágenes menos de 3 segundos después de que el fotógrafo las suba.',
  },
  {
    q: '¿Necesito instalar algo?',
    a: 'No. momentIA funciona 100% en la web. El participante escanea un QR o entra a una URL y saca su selfie desde el navegador.',
  },
  {
    q: '¿Puedo personalizar la experiencia con mi marca?',
    a: 'Sí. En los planes Pro y Enterprise podés personalizar colores, logos, dominios y agregar contenido promocional dentro del álbum de cada usuario.',
  },
];

export const servicesPages = {
  marcas: {
    slug: 'marcas',
    title: 'Marcas',
    hero: 'Convertí cada activación en el recuerdo más valioso del consumidor',
    subtitle: 'Sorprendé a tu audiencia con fotos y videos personalizados que llegan a su smartphone con tu branding, listos para compartir en redes.',
    image: 'https://images.unsplash.com/photo-1665035212282-3e117d618b36?crop=entropy&cs=srgb&fm=jpg&q=85',
    benefits: [
      { title: 'Álbum branded', desc: 'Colores, logo, hashtags y contenido promocional dentro de cada álbum del usuario.' },
      { title: 'Data zero-party', desc: 'Captación de leads y datos enriquecidos con contexto real del evento.' },
      { title: 'Contenido viral', desc: 'Cada foto compartida en redes multiplica el alcance orgánico de tu marca.' },
      { title: 'Reportes en tiempo real', desc: 'Impresiones, descargas, shares y engagement por evento.' },
    ],
    useCases: ['Pop-ups', 'Sampling', 'Lanzamientos', 'Activaciones', 'Sponsors deportivos', 'Field marketing'],
  },
  eventos: {
    slug: 'eventos',
    title: 'Corporativo y MICE',
    hero: 'Recuerdos personales para cada asistente',
    subtitle: 'Congresos, conferencias, galas y fiestas de fin de año: transformá cada evento corporativo en una experiencia memorable que dispara el engagement y el ROI.',
    image: 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?crop=entropy&cs=srgb&fm=jpg&q=85',
    benefits: [
      { title: 'Distribución automática', desc: 'Los asistentes reciben sus fotos sin que nadie tenga que enviarlas.' },
      { title: 'Networking amplificado', desc: 'Álbumes personales que incluyen a quienes estuvieron alrededor.' },
      { title: 'ROI medible', desc: 'Métricas de asistencia, engagement y satisfacción del invitado.' },
      { title: 'Onboarding VIP', desc: 'Cada invitado siente la experiencia como hecha a medida.' },
    ],
    useCases: ['Congresos', 'Conferencias', 'Galas', 'Fiestas de fin de año', 'Kick-offs', 'Team buildings'],
  },
  'fan-experience': {
    slug: 'fan-experience',
    title: 'Experiencia del fan',
    hero: 'La memoria del hincha, en su celular',
    subtitle: 'Convertí cada partido, concierto o show en un recuerdo tangible que fideliza a tu audiencia y monetiza a los sponsors.',
    image: 'https://images.unsplash.com/photo-1665035212282-3e117d618b36?crop=entropy&cs=srgb&fm=jpg&q=85',
    benefits: [
      { title: 'Engagement premium', desc: 'Un touchpoint post-evento que tus fans van a atesorar durante años.' },
      { title: 'Sponsors felices', desc: 'Nuevo inventario premium: la foto que el fan pega en la heladera.' },
      { title: 'CRM enriquecido', desc: 'Datos opt-in de los fans más activos y frecuentes de tu club.' },
      { title: 'Contenido UGC', desc: 'Los fans amplifican la marca en redes al compartir sus fotos.' },
    ],
    useCases: ['Estadios', 'Recitales', 'Festivales', 'Deportes en vivo', 'eSports', 'Espectáculos'],
  },
  deportes: {
    slug: 'deportes',
    title: 'Deportes y competencias',
    hero: 'Cada participante merece llevar su hazaña a casa',
    subtitle: 'Maratones, torneos, triatlones, ciclismo, trail y ligas: entregá las fotos a cada corredor o competidor en tiempo real y multiplicá las ventas por 5x.',
    image: 'https://images.unsplash.com/photo-1452626038306-9aae5e071dd3?crop=entropy&cs=srgb&fm=jpg&q=85',
    benefits: [
      { title: 'Match por dorsal + rostro', desc: 'Combinamos bib recognition y face matching para un 99% de acierto.' },
      { title: 'Entrega en tiempo real', desc: 'El corredor cruza la meta y minutos después ve sus fotos.' },
      { title: 'Ventas x5', desc: 'La conversión se dispara cuando la foto llega antes que el sueño.' },
      { title: 'Cero manual work', desc: 'Nada de subir, taggear, mandar. Todo automático.' },
    ],
    useCases: ['Maratones', 'Triatlones', 'Ciclismo', 'Trail running', 'Ironman', 'Aguas abiertas'],
  },
  hospitality: {
    slug: 'hospitality',
    title: 'Hospitality y cruceros',
    hero: 'Nuevo ingreso ancillary, cero fricción para el huésped',
    subtitle: 'Cruceros, resorts y hoteles boutique: convertí las fotos del staff en un servicio premium que huéspedes valoran y pagan.',
    image: 'https://images.unsplash.com/photo-1445019980597-93fa8acb246c?crop=entropy&cs=srgb&fm=jpg&q=85',
    benefits: [
      { title: 'Ingreso ancillary', desc: 'Nuevo revenue stream sin inversión en hardware ni personal.' },
      { title: 'Guest satisfaction', desc: 'Recuerdos personalizados que elevan la percepción del servicio.' },
      { title: 'Sin galerías públicas', desc: 'Privacy-first: cada huésped ve solo sus propias fotos.' },
      { title: 'Multi-idioma', desc: 'Plataforma disponible en 12 idiomas para huéspedes globales.' },
    ],
    useCases: ['Cruceros', 'Resorts all-inclusive', 'Hoteles boutique', 'Parques temáticos', 'Casinos', 'Ski resorts'],
  },
};
